var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 16 16","fill":"none"}},[_c('path',{attrs:{"d":"M6.66667 2.66675H4V13.3334H6.66667V2.66675Z","fill":_vm.iconColor}}),_c('path',{attrs:{"d":"M12 2.66675H9.33331V13.3334H12V2.66675Z","fill":_vm.iconColor}})])
}
var staticRenderFns = []

export { render, staticRenderFns }